import { render } from "./ListeCategoriePPage.vue?vue&type=template&id=0146f6da&ts=true"
import script from "./ListeCategoriePPage.vue?vue&type=script&lang=ts"
export * from "./ListeCategoriePPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__